import type { SrpProductData } from "~/utils/models";
import { SEARCH_PAGE, SEARCHPAGE_BY_DESIGNATION } from "~/utils/url/staticUrls";

type AutosuggestProductUrlData = Pick<SrpProductData, "designation" | "url">;

export function createSearchPageUrl(text: string) {
  return `${SEARCH_PAGE}?${new URLSearchParams({ text }).toString()}`;
}

export function createCadSearchFallbackUrl(text: string) {
  const params = new URLSearchParams({
    text: text.trim(),
    sort: "relevance",
    initialTabTabular: "true",
  });

  return `${SEARCH_PAGE}?${params.toString()}`;
}

export function createDesignationSearchRedirectUrl(text: string, redirected: boolean) {
  const params = new URLSearchParams({
    text,
    redirect: `${redirected}`,
  });

  return `${SEARCHPAGE_BY_DESIGNATION}?${params.toString()}`;
}

export function createAutosuggestProductUrl(product: AutosuggestProductUrlData) {
  const baseUrl = window.location.origin + (window.__SCHA_BOOT__?.contextPath ?? "") + product.url;
  const url = new URL(baseUrl);
  url.searchParams.set("text", product.designation);

  return url.toString();
}
